
//动态扩散圆
function DiffusionCircleMaterialProperty(options) {
    this._definitionChanged = new Cesium.Event();
    this._color = undefined; //颜色
    this._colorSubscription = undefined;
    this._time = (new Date()).getTime();

    this.color = options.color;
    this.duration = options.duration; //速度
}
Object.defineProperties(DiffusionCircleMaterialProperty.prototype, {
    isConstant: {
        get: function () {
            return false;
        }
    },
    definitionChanged: {
        get: function () {
            return this._definitionChanged;
        }
    },
    color: Cesium.createPropertyDescriptor('color')
});
DiffusionCircleMaterialProperty.prototype.getType = function (time) {
    return  Cesium.Material.DiffusionCircleType;
}
DiffusionCircleMaterialProperty.prototype.getValue = function (time, result) {
    if (!Cesium.defined(result)) {
        result = {};
    }
    result.color = Cesium.Property.getValueOrClonedDefault(this._color, time, Cesium.Color.WHITE, result.color);
    if (this.duration) {
        result.time = (((new Date()).getTime() - this._time) % this.duration) / this.duration;
    }
    //viewer.scene.requestRender();
    return result;
}

DiffusionCircleMaterialProperty.prototype.equals = function (other) {
    return this === other ||
        (other instanceof DiffusionCircleMaterialProperty &&
            Cesium.Property.equals(this._color, other._color))
}


export default DiffusionCircleMaterialProperty;